import IconSwitcher from '@components/common/IconSwitcher'
import { THEME_COLORS } from '@theme/constants';
import { Collapse, Row, Typography, Col } from 'antd';
import Image from 'next/legacy/image';
import React, { useState } from 'react'
import { BsDot } from 'react-icons/bs';
import { FaDotCircle } from 'react-icons/fa';
import styled from 'styled-components';

const { Panel } = Collapse;
const handleIcon = (figuraName) => figuraName ? `/figuras/${figuraName}` : '/img/placeholder.png';


const SubDetalleCard = ({
    id,
    titulo,
    descripcion,
    icon,
    orden,
    createdAt,
    updatedAt,
    deletedAt
}) => {
    const [hovered, setHovered] = useState({ clicked: false, hovered: false });

    const svgSrc = handleIcon(icon)
    return (
        <View>
            {icon && titulo && descripcion &&
                <div
                    onMouseLeave={() => setHovered({ clicked: false, hovered: false })}
                    onMouseEnter={() => setHovered({ ...hovered, hovered: true })} role='button' tabIndex={0}>
                    <Collapse bordered={false} activeKey={hovered.hovered && ['0']} style={{ background: 'none' }} >
                        <Panel forceRender={true} showArrow={false} header={

                            <FullView>
                                <div className="fullWidthIcon">
                                    <Image
                                        src={svgSrc}
                                        width={45}
                                        height={45}
                                        alt="card"
                                        unoptimized={true}
                                    />
                                </div>
                                <div className="fullwidthText">
                                    <p className="strong500">{titulo}</p>
                                </div>
                            </FullView>
                        }>
                            <p className="md">{descripcion}</p>
                        </Panel>
                    </Collapse>
                </div>
            }

            {
                !titulo && !icon &&
                <DotView>

                    <BsDot color={THEME_COLORS.light.secondary.main} size={30} />

                    <p className="md">{descripcion}</p>

                </DotView>
            }

            {
                titulo && descripcion && !icon &&
                <OnlyText>
                    <Typography.Title level={3} style={{ fontWeight: '600' }}>{titulo}</Typography.Title>
                    <p className="md">{descripcion}</p>
                </OnlyText>
            }
        </View>
    )
}

export default SubDetalleCard;

const View = styled.div`
    p.md {
     line-height:25px;
    }
`;

const FullView = styled.div`
    display: flex;
    align-items:center ;
    gap:1em;
    .fullWidthIcon{
        align-items:center;
        background:#fafafaDD;
        height:4em ;
        min-width:4em ;
        display:flex ;
        justify-content:center ;
        border-radius:3em;
    }
    h3.ant-typography {
        color:${THEME_COLORS.light.primary.alt};
        font-size:1.2em ;
        margin:0;
    }
  
     
`;

const DotView = styled.div`

    display:flex;
    svg{
        flex:3;
        
    }
    p{
        flex:36;
    }
    
`;


const OnlyText = styled.div`
    h3.ant-typography {
    color:${THEME_COLORS.light.secondary.main};
    font-size:1.5em ;
    margin:0;
    }
`;